import { FeatureRollout, YammerState } from '../../state/types';
import { isFeatureRolloutEnabled } from '../featureRollouts/selectors';
import { isCurrentNetworkNativeModeSharePointOnlyFileStorage } from '../session/selectors';

type IsNewGroupFilesEnabled = (state: YammerState) => boolean;
export const isNewGroupFilesEnabled: IsNewGroupFilesEnabled = (state) => {
  const isItemsScopeGroupFilesEnabled = isFeatureRolloutEnabled(state, FeatureRollout.ItemsScopeGroupFiles);
  const isItemsScopeGroupFilesNonNativeEnabled = isFeatureRolloutEnabled(
    state,
    FeatureRollout.ItemsScopeGroupFilesNonNative
  );
  const currentNetworkNativeModeSharePointOnlyFileStorage = isCurrentNetworkNativeModeSharePointOnlyFileStorage(state);

  const isNativeModeOrOverridden =
    currentNetworkNativeModeSharePointOnlyFileStorage || isItemsScopeGroupFilesNonNativeEnabled;

  return isItemsScopeGroupFilesEnabled && isNativeModeOrOverridden;
};
